import { render, staticRenderFns } from "./MesaObrasVisadoAptoFinalNewOrEdit.vue?vue&type=template&id=2e408f2b&scoped=true"
import script from "./MesaObrasVisadoAptoFinalNewOrEdit.vue?vue&type=script&lang=js"
export * from "./MesaObrasVisadoAptoFinalNewOrEdit.vue?vue&type=script&lang=js"
import style0 from "./MesaObrasVisadoAptoFinalNewOrEdit.vue?vue&type=style&index=0&id=2e408f2b&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e408f2b",
  null
  
)

export default component.exports